import { getTrackingKey } from '@/utils/api'

import API from './base'

class AccountRecoveryAPI extends API {
  reactivateAccount = ({ customerId, idNumber, checkoutId }) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'reactivate-account'),
      path: this.uri + '/reactivate-account',
      data: {
        customer_id: customerId,
        national_id: idNumber,
        checkout_id: checkoutId,
      },
    })
  }

  createNewAccount = ({ customerId, checkoutId }) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'create-new-account'),
      path: this.uri + '/create-new-account',
      data: {
        customer_id: customerId,
        checkout_id: checkoutId,
      },
    })
  }

  getAccountRecoveryStatus = (checkoutId) => {
    return this.fetcher({
      method: 'GET',
      trackingKey: getTrackingKey(this.uri, 'get-account-recovery-status'),
      path: this.uri + '/status?checkoutId=' + checkoutId,
    })
  }
}

export default new AccountRecoveryAPI('/customers/account-recovery')
